/**
 * +specs: shared shapes for the per-class spec files (docs/design/classes/specs.md).
 *
 * Every class owns ONE file in this folder (warrior.ts, rogue.ts, mage.ts, acolyte.ts, ranger.ts)
 * exporting `<CLASS>_SPEC_INFO` (all three specs, always) and `<CLASS>_SPECS` (the implemented
 * SpecDefs; empty until that class's agent builds them). index.ts concatenates them.
 */
import type { AbilityDef, Role, SpecDef, SpecId, SpecUi } from '@keystone/sim';

/** Preview data for every spec (implemented or not): the Advancement Trial cards and character creation. */
export interface SpecInfo {
  id: SpecId;
  baseClassId: string;
  name: string;
  role: Role;
  /** The recommended launch set (docs/design/classes/advancement.md, bold). */
  launch: boolean;
  ui: SpecUi;
}

/** A SpecDef's preview info (implemented specs derive it from the def). */
export const infoOf = (s: SpecDef, launch: boolean): SpecInfo => ({ id: s.id, baseClassId: s.baseClassId, name: s.name, role: s.role, launch, ui: s.ui! });

/** Every ability of a spec by id (tests, tooltips). */
export const specAbility = (s: SpecDef, id: string): AbilityDef | undefined => s.abilities.find((a) => a.id === id);
